const userInfo = (no: number) => {
    switch (no) {
        case 1:
            return {
                code: "OK",
                desc: "유저 데이터 조회 완료",
                result: {
                    id: "sukim91@ksic.net",
                    platform: "1",
                    name: "김선웅",
                    grade_code: 1,
                    grade: "일반사용자",
                    reg_date: "2020-07-27 13:37:25",
                    map_count: "8"
                },
                flag: true,
            };
        case 2:
            return {
                code: "OK",
                desc: "유저 데이터 조회 완료",
                result: {
                    id: "test@ksic.net",
                    platform: "1",
                    name: "테스트",
                    grade_code: 2,
                    grade: "PRO",
                    reg_date: "2021-09-27 08:34:48",
                    map_count: "0"
                },
                flag: true,
            };
        default:
            return {
                code: "OK",
                desc: "유저 데이터 조회 완료",
                result: {
                    id: "moamap@ksic.net",
                    platform: "1",
                    name: "모아맵테스트",
                    grade_code: 0,
                    grade: "관리자",
                    reg_date: "2020-07-27 09:16:58",
                    map_count: "34"
                },
                flag: true,
            };
    }
};

export default userInfo;
    